import cn from 'classnames/bind';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './styles.styl';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { Button } from '@consta/uikit/Button';
import { Combobox } from '@consta/uikit/Combobox';
import { Informer } from '@consta/uikit/Informer';
import { IconBackward } from '@consta/uikit/IconBackward';
import { DatePicker } from '@consta/uikit/DatePickerCanary';
// @ts-ignore
import { CloudClient } from '../../utils/cloud-client.js';
import { Loader } from '@consta/uikit/Loader';
import {
  ErrorCloudClientType,
  IInputsArrayType,
  IInputsModelType,
  ItemInputs,
} from 'src/utils/type';
import { AnyLogicTypeEnum, StatusInformerEnum } from 'src/utils/enum';
import { formatISO } from 'date-fns';
import AnimationModels from '../AnimationModels';
import { Modal } from '@consta/uikit/Modal';
import { Sidebar } from '@consta/uikit/Sidebar';
import { defaultRunningProperties, randomValue } from 'src/utils/config';
import ResultsCalculationModel from '../ResultsCalculationModel';
import { useDispatch } from 'react-redux';
import { useShallowEqualSelector } from 'src/customHooks/useShallowEqualSelector';
import {
  listHistoryLoadedSelector,
  listHistorySelector,
} from 'src/redux/features/methodModels/listHistory/selectors';
import { State } from 'src/redux/reducer';
import { loadListHistory } from 'src/redux/features/methodModels/listHistory/actions';
import { loadAddHistoryModels } from 'src/redux/features/methodModels/addHistoryModels/actions';
import { loadRunModels } from 'src/redux/features/methodModels/runModels/actions';

const cx = cn.bind(styles);

export interface IRunningModalProps {
  setIsRunningModal: React.Dispatch<React.SetStateAction<boolean>>;
  nameModal: string;
  manual: string;
  modelId: string;
  className?: string;
}

export interface Item {
  [id: string]: {
    name: string;
    type: string;
    units: string;
    value: string | Date;
  };
}

const RunningModal: React.FC<IRunningModalProps> = ({
  className,
  setIsRunningModal,
  nameModal,
  manual,
  modelId,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const dispatch = useDispatch();

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const [listHistory, isLoadedHistory] = useShallowEqualSelector(
    (state: State) => [
      listHistorySelector(state),
      listHistoryLoadedSelector(state),
    ],
  );

  const cloudClient = CloudClient.create(
    randomValue,
    process.env.REACT_ALC_ADEPTUM_URL,
  );

  const [isAnimationgModal, setIsAnimationModal] = useState(false);
  const [isResultModal, setIsResultModal] = useState(false);

  const [inputsObject, setInputsObject] = useState<Item>(null);
  const [inputsData, setInputsData] = useState<IInputsModelType>(null);
  const [version, setVersion] = useState<Item>(null);
  const [outputsValue, setOutputsValue] = useState<IInputsArrayType[]>(null);

  const [errorModel, setErrorModel] = useState(null);

  const [isDisabledCalcButton, setIsDisabledCalcButton] = useState(true);

  const [isLoadingInputs, setIsLoadingInputs] = useState(false);
  const [timerId, setTimerId] = useState<NodeJS.Timeout>();
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');

  useEffect(() => {
    dispatch(loadListHistory(modelId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    cloudClient
      .getLatestModelVersion(nameModal)
      .then((version: any) => {
        const inputs = cloudClient.createDefaultInputs(version);
        setVersion(version);
        setInputsObject(
          inputs.inputsArray.reduce(
            (acc: any, item: IInputsArrayType) => ({
              ...acc,
              [item.name]: {
                name: item.name,
                type: item.type,
                units: item.units,
                value: item.value,
              },
            }),
            {},
          ),
        );
      })
      .catch((error: ErrorCloudClientType) => {
        if (error.status === 404) {
          setErrorModel(
            'Не удалось загрузить исходные данные о модели или такой модели не существует. Попробуйте еще раз',
          );
        }
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsDisabledCalcButton(
      !(
        inputsObject &&
        Object.values(inputsObject)
          .filter((item) => !defaultRunningProperties.includes(item.name))
          .every((item) => item.value)
      ),
    );
  }, [inputsObject]);

  const handleClickAnimtion = useCallback(
    (isAnim: boolean) => {
      // @ts-ignore
      const newObj: ItemInputs[] = Object.values(inputsObject)
        .filter((item) => item.value)
        .map((item) => {
          return item.type === AnyLogicTypeEnum.DATE_TIME &&
            item.value instanceof Date
            ? { ...item, value: formatISO(new Date(item.value.toUTCString())) }
            : item;
        });

      const inputs = cloudClient.createDefaultInputs(version);

      newObj.map((item) => {
        inputs.setInput(item.name, item.value);
      });

      setInputsData(inputs);

      const simulation = cloudClient.createSimulation(inputs);

      setIsLoadingInputs(true);
      return simulation
        .getOutputsAndRunIfAbsent()
        .then((outputs: { outputs: IInputsArrayType[] }) => {
          setOutputsValue(outputs?.outputs);
          setIsLoadingInputs(false);
          dispatch(loadRunModels(modelId));
          dispatch(
            loadAddHistoryModels(
              {
                items: newObj.map(({ name, value, type, units }) => ({
                  name,
                  value,
                  type,
                  units,
                })),
              },
              modelId,
            ),
          );
          if (isAnim) {
            setIsAnimationModal(true);
          } else {
            setIsResultModal(true);
          }
        })
        .catch((error: any) => {
          console.log(error);
          setTitle('Введено недопустимое значение параметров');
          if (timerId) clearTimeout(timerId);
          setIsOpen(true);
          setTimerId(
            setTimeout(() => {
              setIsOpen(false);
            }, 5000),
          );
          setIsLoadingInputs(false);
        });
    },
    [cloudClient, dispatch, inputsObject, modelId, timerId, version],
  );

  const handleCreateCombobox = useCallback(
    (value, item) => {
      if (item.type === AnyLogicTypeEnum.STRING || !isNaN(Number(value))) {
        setInputsObject((prev) => {
          const newObj = { ...prev };
          newObj[item.name].value = value;
          return newObj;
        });
      } else {
        setTitle('Некорректный формат данных');
        if (timerId) clearTimeout(timerId);
        setIsOpen(true);
        setTimerId(
          setTimeout(() => {
            setIsOpen(false);
          }, 5000),
        );
      }
    },
    [timerId],
  );

  return (
    <div className={cx('RunningModal', className)}>
      <div className={cx('RunningModal__title')}>
        {isMobile && (
          <Button
            className={cx('RunningModal__buttonCloseMobile')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconBackward}
            onClick={() => setIsRunningModal(false)}
          />
        )}
        <Text className={cx('RunningModal__data')} weight="semibold">
          Введите исходные данные
        </Text>
        {!isMobile && (
          <Button
            className={cx('RunningModal__buttonClose')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconClose}
            onClick={() => setIsRunningModal(false)}
          />
        )}
      </div>
      <div className={cx('RunningModal__content')}>
        {manual && (
          <div className={cx('RunningModal__manual')}>
            <Text
              size="s"
              className={cx('RunningModal__manualTitle')}
              view="secondary"
            >
              Инструкция по использованию
            </Text>
            <Text
              size="s"
              lineHeight="l"
              className={cx('ViewModal__descriptionText')}
            >
              {manual}
            </Text>
          </div>
        )}
        {errorModel && !inputsObject && (
          <div>
            <Text className={cx('RunningModal__error')} view="alert">
              {errorModel}
            </Text>
          </div>
        )}
        {!inputsObject && !errorModel && !isLoadedHistory && <Loader />}
        {inputsObject && (
          <div className={cx('RunningModal__gridInput')}>
            {Object.values(inputsObject).map((item, index) => (
              <div key={index}>
                {item.type === AnyLogicTypeEnum.DATE_TIME ? (
                  <DatePicker
                    type="date"
                    className={cx('RunningModal__datePicker')}
                    label={item.name}
                    size="s"
                    value={new Date(item.value)}
                    onChange={({ value }) =>
                      setInputsObject((prev) => {
                        const newObj = { ...prev };
                        newObj[item.name].value = value;
                        return newObj;
                      })
                    }
                  />
                ) : (
                  <Combobox
                    size="s"
                    label={item.name}
                    required={!defaultRunningProperties.includes(item.name)}
                    value={(() => {
                      if (inputsObject[item.name].value) {
                        return inputsObject[item.name];
                      }
                      return null;
                    })()}
                    getItemKey={(item) => String(item.value)}
                    getItemLabel={(item) => String(item.value)}
                    items={listHistory
                      .map(({ name, value, type, units }) => ({
                        name,
                        value,
                        type,
                        units,
                      }))
                      .filter((data) => data.name === item.name)}
                    onCreate={({ label }) => handleCreateCombobox(label, item)}
                    onChange={({ value }) => {
                      setInputsObject((prev) => {
                        const newObj = { ...prev };
                        newObj[item.name].value = value?.value;
                        return newObj;
                      });
                    }}
                    className={cx('RunningModal__combobox')}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={cx('RunningModal__save')}>
        <div className={cx('RunningModal__saveContent')}>
          <Button
            onClick={() => {
              setIsRunningModal(false);
            }}
            label="Отмена"
            size="s"
            view="ghost"
            className={cx('RunningModal__buttonSave')}
          />
          <Button
            onClick={() => handleClickAnimtion(false)}
            size="s"
            label={'Рассчитать'}
            disabled={isDisabledCalcButton}
            className={cx('RunningModal__buttonSave')}
            loading={isLoadingInputs}
          />
        </div>
        <Button
          onClick={() => handleClickAnimtion(true)}
          size="s"
          label={'Рассчитать с визуализацией'}
          className={cx('RunningModal__buttonCalcVisual')}
          disabled={isDisabledCalcButton}
          loading={isLoadingInputs}
        />
      </div>
      {isMobile ? (
        <Sidebar
          className={cx('RunningModal__animationModels')}
          position="left"
          isOpen={isAnimationgModal}
          size="full"
        >
          <Sidebar.Content className={cx('RunningModal__animationModels')}>
            <AnimationModels
              outputsValue={outputsValue}
              setIsAnimationModal={setIsAnimationModal}
              cloudClient={cloudClient}
              nameModal={nameModal}
              inputsData={inputsData}
              setIsRunningModal={setIsRunningModal}
            />
          </Sidebar.Content>
        </Sidebar>
      ) : (
        <Modal
          position="center"
          isOpen={isAnimationgModal}
          hasOverlay
          className={cx('RunningModal__animationModelsModel')}
        >
          <AnimationModels
            outputsValue={outputsValue}
            setIsAnimationModal={setIsAnimationModal}
            cloudClient={cloudClient}
            nameModal={nameModal}
            inputsData={inputsData}
            setIsRunningModal={setIsRunningModal}
          />
        </Modal>
      )}
      {isMobile ? (
        <Sidebar
          className={cx('RunningModal__sideBar')}
          position="left"
          isOpen={isResultModal}
          size="full"
        >
          <Sidebar.Content className={cx('RunningModal__sideBarContent')}>
            <ResultsCalculationModel
              outputsValue={outputsValue}
              setIsResultModal={setIsResultModal}
              nameModal={nameModal}
              setIsRunningModal={setIsRunningModal}
            />
          </Sidebar.Content>
        </Sidebar>
      ) : (
        <Modal
          position="center"
          isOpen={isResultModal}
          hasOverlay
          className={cx('RunningModal__modalResultsCalculation')}
        >
          <ResultsCalculationModel
            outputsValue={outputsValue}
            setIsResultModal={setIsResultModal}
            nameModal={nameModal}
            setIsRunningModal={setIsRunningModal}
          />
        </Modal>
      )}
      {isOpen && (
        <Informer
          status={StatusInformerEnum.Alert}
          size="s"
          title={title}
          onClick={() => {
            setIsOpen(false);
            if (timerId) clearTimeout(timerId);
          }}
          className={cx('RunningModal__informer')}
        />
      )}
    </div>
  );
};

export default RunningModal;
